import { DotsVerticalIcon } from './DotsVerticalIcon';

/**
 * author: Google
 * id 5D70B3D1-8407-42C9-A3C1-42EE68FF18F3
 * name dots-vertical
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-vertical.svg
 * tags
 */
export const EllipsisVerticalIcon = DotsVerticalIcon;
export default EllipsisVerticalIcon